import React from "react";
import {
  Panel,
  PanelRow,
  Label,
  PanelHeading,
  PanelSpacer,
  Button,
  PageHeadingAreaSpacer,
  PanelActions,
  TextInput,
  DatePicker,
} from "@backslashbuild/pp-ui";

import InvoiceCategoryPicker from "./InvoiceCategoryPicker";
import AgencyPicker from "./AgencyPicker";
import { usePost } from "./api";
import { publish } from "../../pubSub";
import { currentDateUtc } from "./utils";
import useCurrentTaxWeek from "../tax-calendar/useCurrentTaxWeek";

export default function CreateInvoiceForm({ onClose = () => {} }) {
  const [invoiceDate, setInvoiceDate] = React.useState(currentDateUtc());
  const [agencyNumber, setAgencyNumber] = React.useState("");
  const [weekNumber, setWeekNumber] = React.useState(useCurrentTaxWeek());
  const [invoiceCategory, setInvoiceCategory] = React.useState("");

  const create = usePost();

  function handleSubmit() {
    create(`create`, {
      invoiceDate,
      invoiceCategoryId: invoiceCategory,
      agencyNumber,
      weekNumber: weekNumber.toString(),
    }).then((res) => {
      if (res?.isSuccess) {
        publish("notification", "Invoice created");
        onClose();
      } else {
        publish("notification", "Unable to create invoice: " + res.errors);
        console.log(res.errors);
      }
    });
  }

  return (
    <>
      <Panel>
        <PanelHeading>Invoice</PanelHeading>
        <PanelSpacer />
        <PanelRow>
          <Label label="Invoice Date">
            <DatePicker value={invoiceDate} onChange={(e) => setInvoiceDate(e)} />
          </Label>
        </PanelRow>
        <PanelSpacer />
        <PanelRow>
          <Label label="Week Number">
            <TextInput value={weekNumber} onChange={(e) => setWeekNumber(e.target.value)} />
          </Label>
        </PanelRow>
        <PanelSpacer />
        <PanelRow>
          <Label label="Category">
            <InvoiceCategoryPicker value={invoiceCategory} onChange={setInvoiceCategory} />
          </Label>
        </PanelRow>
        <PanelSpacer />
        <PanelRow>
          <Label label="Agency">
            <AgencyPicker value={agencyNumber} onChange={setAgencyNumber} />
          </Label>
        </PanelRow>
        <PanelSpacer />
        <PanelActions>
          <Button large variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <PageHeadingAreaSpacer />
          <Button large onClick={() => handleSubmit()}>
            Submit
          </Button>
        </PanelActions>
      </Panel>
    </>
  );
}
